module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_convenience-a8d217a357c2846ae6cbe337edac58f2.png";